<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div *ngIf="viewType=='Compact'" class="compact-breadcumb-view flex flex-row justify-start items-center">
    <particle-select-basket *ngIf="sourceType" (basketChange)="onBasketChange($event)"
                            [ignoreBasket]="currentConfig.ignoreBasket" class="m-l-30 m-r-20"></particle-select-basket>
    <particle-breadcumb-tab-action
      [breadcrumbs]="breadcrumbs"
      [actions]="actions"
      (viewTypeChanged)="viewTypeChanged($event)"
      (selectedTabChanged)="onSelectedTabChanged($event)"

    >
    </particle-breadcumb-tab-action>
  </div>
  <div *ngIf="viewType!='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-start items-center">
      <particle-select-basket *ngIf="sourceType" (basketChange)="onBasketChange($event)"
                              [ignoreBasket]="currentConfig.ignoreBasket" class="m-r-20"></particle-select-basket>
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
      <!--<div fxLayout="row" fxLayoutAlign="space-between center" >
        <particle-select-basket></particle-select-basket>
        <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
      </div>-->
      <button class="view-change" (click)="compactViewType()">
        <i class="fas fa-expand-alt"></i>
      </button>
    </div>
  </div>
  <div *ngIf="viewType!='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div *ngIf="!caseId" class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="Add()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Add Record
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="manageEntities()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Manage Entities
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          <particle-grid-apply-filter *ngIf="sourceType && filterId" [filterId]="filterId"-->
        <!--                                      [endpointName]="endpoint"-->
        <!--                                      [invalidateSubject]="invalidateSubject">-->
        <!--          </particle-grid-apply-filter>-->

        <!--          <div class="toolbar-separator m-l-10"></div>-->
        <!--        </div>-->
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="import()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Import
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="export()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Export
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="manageSection()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="manage-fields"
          >Manage Fields
          </button>

          <div class="toolbar-separator"></div>
        </div>
      </div>
      <div *ngIf="caseId" class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="exportByCaseId()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Export
          </button>

          <div class="toolbar-separator"></div>
        </div>
      </div>
    </div>
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
        <button mat-button class="start-data-survey" (click)="startDataSurvey()"><i class="fal fa-play"></i>
          Create Survey Template
        </button>
      </div>
    </div>
  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div *ngIf="sourceType" class="center">


      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="{{currentConfig.helpNoteId}}" class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->


        <div [ngClass]="hasTabs ? 'content pos-relative' : 'content pos-relative m-30'"
             class="flex flex-col full-grow-no-shrink-no-basis">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceType"
                                   sortFieldKey="EntityCode"
                                   sortDirection="asc"
                                   prefixSortFieldKey="FieldValues."
                                   [sortEnabled]="true"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
                                   (fieldSectionChanged)="onFieldSectionChanged($event)"
                                   [viewType]="viewType"
                                   serviceName="{{sourceType.replace('-','')+'DynamicItemService'}}"
                                   api="DAC6Api"
            >
            </particle-virtual-grid>
          </div>
        </div>


      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
